module.exports = __webpack_public_path__ + "static/media/fo.c0132fc0.svg";